module.exports = __webpack_public_path__ + "img/multi.48153eea.svg";